<!--*ngIf="_DataHelper.numberOfBets == 1 && _UiHelper.bottomDialogState == false && this._UiHelper.quickTippIsActive" => Test Edilecek-->

<div class="quick-tipp text" *ngIf="currentSlipListLength == 1 && _UiHelper.bottomDialogState == false && this._UiHelper.quickTippIsActive">
  <div class="quick-tipp-container">
    <div class="quick-tipp-header">
      <div class="title">
        {{ 'b3000_quick_bet' | t }}
        <div class="settings">
          <div id="quickTippSettingsIcon" (click)="openRightMenu()">
            <image-loader-utils url="settings" extraClasses="setting-icon white-color"></image-loader-utils>
          </div>
        </div>
      </div>
      <div (click)="closeQuickTipp()">
        <image-loader-utils url="close" extraClasses="close-icon white-color"></image-loader-utils>
      </div>
    </div>

    <div class="quick-tipp-content">
      <ng-container *ngFor="let slipEvent of this._DataHelper.currentSlipData.reverse() | groupByEventName | slice : 0 : 1; first as isFirst">
        <div class="match-row" (click)="goEventDetail(slipEvent)">
          <div class="match-info">
            <div class="team-name">{{ slipEvent.HomeTeam }}</div>
            <div class="team-name">{{ slipEvent.AwayTeam }}</div>
          </div>
          <div class="match-score" *ngIf="!getLiveEvent(slipEvent.MatchId)">
            <div class="score-box"></div>
            <div class="score-box now">
              <div class="text">
                {{ (slipEvent.EventDateLong | dateFormat : 'dd-MM') == (this.today | dateFormat : 'dd-MM') ? ('today' | t) : (slipEvent.EventDateLong | dateFormat : 'dd.MM') }}
              </div>
              <div class="text">
                {{ (slipEvent.EventDateLong | dateFormat : 'dd-MM') == (this.today | dateFormat : 'dd-MM') ? '' : (slipEvent.EventDateLong | dateFormat : 'HH:mm') }}
              </div>
            </div>
          </div>
          <div class="match-score" *ngIf="getLiveEvent(slipEvent.MatchId) as eventObj">
            <div class="score-box">
              {{ eventObj.TimeStatu != 3 ? (eventObj.MatchTime != null ? eventObj.MatchTime + "'" : '') : eventObj.TimeStatuColor.trim() }}
            </div>
            <div class="score-box now">
              <span>
                {{ eventObj.Score != null && eventObj.Score !== '' ? eventObj.Score.split(':')[0] : '' }}
              </span>
              <span>
                {{ eventObj.Score != null && eventObj.Score !== '' ? eventObj.Score.split(':')[1].trim() : '' }}
              </span>
            </div>
          </div>
        </div>
        <div class="odd-box">
          <div class="odd-row" *ngFor="let slipCurrent of slipEvent?.eEvents">
            <div class="odd">
              <div class="left">
                {{ slipCurrent.OddsType }} {{ slipCurrent.SpecialBetValue }}&nbsp;:&nbsp;<b>{{ slipCurrent.OutCome }}</b>
              </div>
              <div class="mid"></div>
              <div class="right">
                {{ slipCurrent.OddValue1 | number : '1.2-2' }}
              </div>
            </div>
            <div class="close" (click)="removeOdd(slipCurrent.OddId1)">
              <image-loader-utils url="times" extraClasses="times-icon"></image-loader-utils>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="quick-tipp-bottom">
      <ng-container *ngIf="!keyboardIsOpen">
        <ng-container *ngIf="placeBetIsActive">
          <div class="left">
            <div class="quick-tipp-modify" (click)="placeBetStatus(false)">
              {{ 'Modify' | t }}
            </div>
          </div>
          <div class="right">
            <!-- <div class="quick-tipp-confirm" (click)="placeBet()" *ngIf="this._DataHelper.selectedWallet.BranchType != 0; else noPlaceConfirm"> -->

            <div class="quick-tipp-confirm" (click)="placeBet()">
              <div class="first-text">
                {{ 'Confirm' | t }}
              </div>
              <div class="second-text">
                {{ 'b3000_Accept_odds_change' | t }}
              </div>
            </div>
            <ng-template #noPlaceConfirm>
              <div class="quick-tipp-confirm" style="opacity: 0.5 !important">
                <div class="first-text">
                  {{ 'Confirm' | t }}
                </div>
                <div class="second-text">
                  {{ 'b3000_Accept_odds_change' | t }}
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>

        <ng-container *ngIf="!placeBetIsActive">
          <div class="left" (click)="changeKeyboardState(true)">
            <div class="quick-tipp-total-stake">
              <div class="total-stake-value">
                {{ this._DataHelper.currentSlipInfo.currentslip_totalStake?.toFixed(2) }}
                {{ _UserHelper.customerUser?.Symbol }}
              </div>
              <div class="total-stake-text">
                {{ 'Total_Stake' | t }}
              </div>
            </div>
          </div>
          <div class="right">
            <ng-container *ngIf="!this._UserHelper.isSignedIn">
              <div id="quickTippLoginButton" class="quick-tipp-login" (click)="openRightMenu()">
                {{ 'login' | t }}
              </div>
            </ng-container>
            <ng-container *ngIf="this._UserHelper.isSignedIn">
              <!-- <div class="quick-tipp-submit" (click)="placeBetStatus(true)" *ngIf="this._DataHelper.selectedWallet.BranchType != 0; else noPlace"> -->

              <div class="quick-tipp-submit" (click)="placeBetStatus(true)">
                <div class="submit-text">
                  {{ 'b3000_submit_bet' | t }}
                </div>
                <div class="max-win">{{ 'Possible_winnings' | t }} {{ maxGain }} {{ _UserHelper.customerUser?.Symbol }}</div>
              </div>
              <ng-template #noPlace>
                <div class="quick-tipp-submit" style="opacity: 0.5 !important">
                  <div class="submit-text">
                    {{ 'b3000_submit_bet' | t }}
                  </div>
                  <div class="max-win">{{ 'Possible_winnings' | t }} {{ maxGain }} {{ _UserHelper.customerUser?.Symbol }}</div>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="keyboardIsOpen">
        <div class="quick-tipp-keyboard">
          <div class="keyboard-total-stake-row">
            <div class="left-side">{{ 'Total_Stake' | t }}</div>
            <div class="right-side">
              <div class="keyboard-total-stake-input">
                <div class="keyboard-total-stake">
                  {{ this._DataHelper.currentSlipInfo.currentslip_totalStake }}
                </div>
                <div class="keyboard-total-stake-currency">
                  {{ _UserHelper.customerUser?.Symbol }}
                </div>
              </div>
            </div>
          </div>
          <div class="slip-amount-keyboard">
            <div class="left-side">
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(1)">1</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(2)">2</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(3)">3</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(4)">4</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(5)">5</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(6)">6</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(7)">7</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(8)">8</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(9)">9</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000('.')">.</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(0)">0</div>
              <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(0, 'backspace')">
                <image-loader-utils url="back"></image-loader-utils>
              </div>
            </div>
            <div class="right-side">
              <div class="keyboard-button right" (click)="changeStakeInKeyboardB3000(0, '+10')">+ 10</div>
              <div class="keyboard-button right" (click)="changeStakeInKeyboardB3000(0, '+50')">+ 50</div>
              <div class="keyboard-button right" (click)="changeStakeInKeyboardB3000(1, 'C')">C</div>
              <div class="keyboard-button right" (click)="changeKeyboardState(false)">OK</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
